import { useProjectStore } from "@/stores/projectStore"
import { useAnalyticsStore } from "@/stores/analyticsStore"
import { useOnboardingStore } from "@stores/onboardingStore"
import { clearAuthCache } from "@/services/clerk"

/**
 * Clears all application state when switching organizations
 * This ensures a clean slate when moving between organizations
 */
export const clearAllState = () => {
   clearAuthCache()
   const projectStore = useProjectStore()
   const analyticsStore = useAnalyticsStore()
   const onboardingStore = useOnboardingStore()

   // Clear project store state
   projectStore.projectId = null
   projectStore.projectName = null
   projectStore.projects = []
   projectStore.variables = []

   // Clear overview store state
   analyticsStore.clearState()
   onboardingStore.clearState()
}
